import React from "react";
import { useNavigate } from "react-router-dom";
import { colorTokens, getSpacing, typographyTokens } from "../../../designTokens";
import { PERMISSION_GROUP_NOT_CONFIGURED_MESSAGE } from "../../../utils/teamLeaderAccess";
import { performLogout } from "../../../auth/performLogout";

interface PermissionGroupErrorScreenProps {
  idPrefix?: string;
}

const PermissionGroupErrorScreen: React.FC<PermissionGroupErrorScreenProps> = ({
  idPrefix = "permission-group-error",
}) => {
  const navigate = useNavigate();

  const handleBackToLogin = async () => {
    await performLogout({ callLogoutApi: true });
    navigate("/", { replace: true });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: getSpacing("24px"),
        backgroundColor: colorTokens["Background/Greyish"],
      }}
      id={`${idPrefix}-container`}
      role="alert"
    >
      <div
        style={{
          maxWidth: "480px",
          padding: getSpacing("32px"),
          backgroundColor: colorTokens["Background/White"],
          borderRadius: getSpacing("16px"),
          border: `1px solid ${colorTokens["Borders/Light"]}`,
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontFamily: typographyTokens["Headings/H3"].family,
            fontSize: `${typographyTokens["Headings/H3"].size}px`,
            fontWeight: typographyTokens["Headings/H3"].weight,
            color: colorTokens["Text/Black"],
            margin: `0 0 ${getSpacing("16px")}`,
          }}
          id={`${idPrefix}-message`}
        >
          {PERMISSION_GROUP_NOT_CONFIGURED_MESSAGE}
        </p>
        <button
          type="button"
          onClick={() => void handleBackToLogin()}
          style={{
            padding: `${getSpacing("12px")} ${getSpacing("24px")}`,
            borderRadius: getSpacing("8px"),
            border: "none",
            backgroundColor: colorTokens["Primary/Default"],
            color: colorTokens["Background/White"],
            cursor: "pointer",
            fontFamily: typographyTokens["Body/Medium"].family,
            fontSize: `${typographyTokens["Body/Medium"].size}px`,
          }}
          id={`${idPrefix}-back-button`}
        >
          Back to login
        </button>
      </div>
    </div>
  );
};

export default PermissionGroupErrorScreen;
